// UserMetaData reducer
const userMetadataInitialState = {
    firstName: null,
    lastName: null,
    fullName: null,
    email: null,
    uid: null,
    profileImage: null,
    profileImageDescriptor: null
};

export const userMetadataReducer = (state = userMetadataInitialState, action) => {
    switch (action.type) {
        case "SET_USER_METADATA":
            return { ...state, ...action.payload };
        case "CLEAR_USER_METADATA":
            return userMetadataInitialState;
        default:
            return state;
    }
};